import Rendable from '@/glxp/abstract/rendable'
import Shader from '@/glxp/utils/shader'
import Node from '@/glxp/abstract/node'

import GEOM from '@/glxp/geom/plane'
import ShaderManifest from '../shaderManifest'

class Plane extends Rendable {
  constructor (scene, shader, texture, options) {
    super(scene)

    this.gl = scene.gl
    this.scene = scene
    this.shaderType = shader
    this.texture = texture
    
    this.node = new Node()
    this.shader = new Shader(ShaderManifest[shader])

    this.options = options
    /*
    {
      spriteDimension: 5
      speed: 1
    }
    */

    this.hasNormal = false
    this.initBuffer({
      vertices: GEOM.vertices,
      uvs: GEOM.uvs,
      indices: GEOM.indices
    })

    this.initProgram(this.shader.vert, this.shader.frag)
    this.initVao()
    this.initMatrix()
    this.createUniforms()
  }

  createUniforms () {
    this.createUniform('uTexture', 'texture')
    this.createUniform('uTime')
    if (this.shaderType == "sprite") {
      this.createUniform('uSpriteDim')
    }
  }

  applyState () {
    let gl = this.gl

    this.scene.applyDefaultState()

    gl.disable(gl.CULL_FACE)
    gl.disable(gl.DEPTH_TEST)
    gl.depthMask(false)
  }

  preRender(){
  
  }

  render () {

    this.preRender()

    let gl = this.gl
    gl.useProgram(this.program)
    gl.bindVertexArray(this.vao)
    this.applyState()

    gl.activeTexture(gl.TEXTURE0)
    gl.bindTexture(gl.TEXTURE_2D, this.scene.textureLoader.getTexture(this.texture))
    this.bindUniform('uTexture', 0)
    this.bindMatrixUniforms(this.scene.camera)


    if (this.shaderType == "sprite") {
      this.bindUniform('uSpriteDim', this.options.spriteDimension)
      this.bindUniform('uTime', (this.scene.time * this.options.speed) % this.options.spriteDimension)
    }

    gl.drawElements(gl.TRIANGLES, GEOM.indices.length, gl.UNSIGNED_SHORT, 0)
    gl.bindVertexArray(null)
  }
}

export default Plane
